import layout from '@/layout'

export default {
  path: '/winner',
  component: layout,
  redirect: '/winner/self_mock',
  name: 'winner_self_mock',
  meta: {
    title: 'winner',
    icon: 'winner'
  },
  children: [
    {
      path: '/winner/self_mock',
      name: 'winner_self_mock',
      component: () => import('@/views/winner/pages/winner_self_mock/index.vue'),
      meta: {
        title: 'winner_self_mock',
        icon: 'bang'
      }
    }
  ]
}
